import React from 'react'
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Theme } from '@mui/material/styles'

export interface TextElement {
  headline3?: string
  headline1?: string
  headline2?: string
  content: string
  imagePath?: string
}
interface ITextProps {
  columns: number
  elements: TextElement[]
  align?: 'left' | 'right' | 'center'
}
const Text: React.FC<ITextProps> = (props) => {
  const theme: Theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <>
      <Stack
        direction={{ xs: 'row' }}
        spacing={{ md: 0 }}
        sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}
      >
        {props.elements.map((element, index) =>
          <Box
            key={index} sx={{
              width: downMd ? '100%' : `${100 / props.columns}%`,
              padding: downMd ? `${theme.spacing(2)} 0` : theme.spacing(2),
              textAlign: props.align || 'left',
            }}
          >
            <img style={{ margin: downMd ? `${theme.spacing(1)} 0` : `${theme.spacing(1)} ${theme.spacing(2)}`, maxWidth: downMd ? '100%' : '50%', height: 'auto' }} src={element.imagePath} />

            {element.headline1 &&
              <Typography variant='h1'>{element.headline1}</Typography>}
            {element.headline2 &&
              <Typography variant='h2'>{element.headline2}</Typography>}
            {element.headline3 &&
              <Typography variant='h3'>{element.headline3}</Typography>}
            <Typography variant='body1'>{element.content}</Typography>
          </Box>,
        )}
      </Stack>
    </>
  )
}
export default Text
